var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuesaxlineareyeSlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies",
    transform: "translate(-740.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-slash",
    transform: "translate(740.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4157229,20.5840555 C12.4948896,19.6632222 11.9282227,18.4023892 11.9282227,16.9998892 C11.9282227,14.1948892 14.1948892,11.9282227 16.9998892,11.9282227 C18.4023892,11.9282227 19.6632222,12.4948896 20.5840555,13.4157229 L13.4157229,20.5840555 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.244778,8.17413894 C22.7656113,6.30413887 19.9322783,5.284139 16.9997784,5.284139 C11.9989451,5.284139 7.33811186,8.23080556 4.09394524,13.3308054 C2.81894528,15.3283054 2.81894528,18.6858069 4.09394524,20.6833069 C5.21311194,22.4399735 6.51644496,23.9558069 7.93311163,25.1741403",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9282227,27.6677496 C13.5432226,28.3477495 15.2573892,28.7160826 16.9998892,28.7160826 C22.0007225,28.7160826 26.6615568,25.769416 29.9057234,20.6694161 C31.1807234,18.6719162 31.1807234,15.3144153 29.9057234,13.3169154 C29.4382234,12.5802488 28.9282227,11.8860824 28.4040548,11.2344157",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9731096,17.9919434 C21.6047763,19.9894433 19.9756087,21.618611 17.9781087,21.9869443",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4158337,
    y1: 20.5838623,
    x2: 2.83333333,
    y2: 31.1663627,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1670544,
    y1: 2.83333333,
    x2: 20.584554,
    y2: 13.4158337,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(17.000000, 17.000000) rotate(-180.000000) translate(-17.000000, -17.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxlineareyeSlash);
export default __webpack_public_path__ + "static/media/vuesaxlineareye-slash.914dc8b06d6dbeb18640c367e591a871.svg";
export { ForwardRef as ReactComponent };